/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ConceptNodeDescription } from './conceptNodeDescription';
import type { ConceptNodeClusterId } from './conceptNodeClusterId';

/**
 * A node in the concept graph.
 */
export interface ConceptNode {
  id: string;
  label: string;
  description?: ConceptNodeDescription;
  clusterId?: ConceptNodeClusterId;
  isCore?: boolean;
  /** 1: Central Pillars, 2: Core, 3: Peripheral */
  relevanceTier?: number;
}
